import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import { Tag } from 'antd';
const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'realName', label: '教师名称', width: 120 },
    { key: 'courseName', label: '课程名称', width: 120 },
    // {key:'codeName1', label: '课程类型I',width : 120},
    // {key:'codeName2', label: '课程类型II',width : 120},
    // {key:'codeName3', label: '课程类型III',width : 120},
    // {key:'codeName4', label: '课程类型IV',width : 120},
    // {key:'majorName', label: '专业名称' ,width : 120},
    // {key:'classesName', label: '班级名称' ,width : 120},
    // {key:'studentName', label: '学生姓名' ,width : 120},
    // {key:'graduationGrade', label: '届别' ,width : 120},
    // {key:'employeeName', label: '指导教师' ,width : 120},
    // {key:'title', label: '论文题目' ,width : 120},
    {
        key: 'submitStatus', label: '提交状态', width: 100, render: (val) => {
            if (val === 2) {
                return <Tag color='green'>正式提交</Tag>
            } else {
                return <Tag color='blue'>预提交</Tag>
            }
        }
    },
    { key: 'termName', label: '开课学期', width: 120 },
]);

const columnsArray = [
    { type: 'selection' },
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'realName', label: '教师名称', width: 120 },
    { key: 'courseName', label: '课程名称', width: 120 },
    // {key:'codeName1', label: '课程类型I',width : 120},
    // {key:'codeName2', label: '课程类型II',width : 120},
    // {key:'codeName3', label: '课程类型III',width : 120},
    // {key:'codeName4', label: '课程类型IV',width : 120},
    // {key:'majorName', label: '专业名称' ,width : 120},
    // {key:'classesName', label: '班级名称' ,width : 120},
    // {key:'studentName', label: '学生姓名' ,width : 120},
    // {key:'graduationGrade', label: '届别' ,width : 120},
    // {key:'employeeName', label: '指导教师' ,width : 120},
    // {key:'title', label: '论文题目' ,width : 120},
    {
        key: 'certifyStatus', label: '审核状态', width: 100, render: (val) => {
            if (val === 2) {
                return <Tag color='green'>审核通过</Tag>
            } else if (val === 3) {
                return <Tag color='red'>审核不通过</Tag>
            } else if (val === 0) {
                return <Tag color='purple'>待申请认证</Tag>
            } else if (val === 1) {
                return <Tag color='blue'>待专业审核</Tag>
            } else if (val === 4) {
                return <Tag color='red'>专业审核不通过</Tag>
            } else if (val === 5) {
                return <Tag color='rgb(106 223 216)'>待院部审核</Tag>
            } else if (val === 6) {
                return <Tag color='red'>院部审核不通过</Tag>
            } else if (val === 7) {
                return <Tag color='rgb(100 186 240)'>待校级审核</Tag>
            }
        }
    },
    {key: 'fileNum', label: '文件数量', width: 100},
    { key: 'zyAuditContent', label: '专业评价', width: 100 },
    { key: 'xbAuditContent', label: '院部评价', width: 100 },
    { key: 'xjAuditContent', label: '校级评价', width: 100 },
    {
        key: 'submitStatus', label: '提交状态', width: 100, render: (val) => {
            if (val === 2) {
                return <Tag color='green'>正式提交</Tag>
            } else {
                return <Tag color='blue'>预提交</Tag>
            }
        }
    },
    { key: 'termName', label: '开课学期', width: 120 },
];

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/course/querycourse?' + params.join('&'), keywords)
        .then(response => {
            let extParams = response.payload.meta.extParams;
            let newArray = []
            if (extParams.courseTypeList && extParams.courseTypeList.length > 0) {
                for (let i = 0; i < columnsArray.length; i++) {
                    if (i === 4) {
                        extParams.courseTypeList.forEach((o, index) => {
                            if (o.isShow) {
                                if (index === 4) {
                                    newArray.push({
                                        key: 'classesName',
                                        label: '班级名称',
                                        width: 100
                                    })
                                } else {
                                    newArray.push({
                                        key: `codeName${index + 1}`,
                                        label: o.label,
                                        width: 100
                                    })
                                }
                            }
                        })
                    }
                    newArray.push(columnsArray[i])
                }
            }
            return {
                data: response.payload.data,
                headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
            }
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

const getDetailById = (id) => {
    return fetch.get(`graduation/course/getDetailById/${id}`)
}

const getDetailByInfo = (data) => {
    return fetch.post('graduation/course/getDetailByInfo/', data)
}

const getTermByBatchCode = (batchCode) => {
    return fetch.get('graduation/course/getTermByBatchCode/'+ batchCode, {})
    .then(response => response.payload.data);
}

const getStudentContentById = (id) => {
    return fetch.get(`graduation/result/get/student/content/${id}`)
}

const remove = (ids) => {
    return fetch.post('graduation/course/delete', ids)
}

const update = (data) => {
    return fetch.post('graduation/course/update/' + data.id, data)
}

const saveComment = (data) => {
    return fetch.post('graduation/comment/save/', data)
}

const queryCourseType = (typeId) => {
    return fetch.post('platform/code/course/type/' + typeId, {})
        .then(response => {
            return response.payload.data;
        }).then(data => {
            return data.map(function (d) {
                return {
                    value: +d.codeValue,
                    label: d.codeName
                }
            });
        });
}

const courseTypeControl = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.get('platform/param/get/courseTypeControl')
        .then(response => {
            return response.payload.data;
        })
}

const submit = (ids) => {
    return fetch.post('graduation/course/submit', ids)
}

const back = (ids) => {
    return fetch.post('graduation/course/back', ids)
}

const certify = (data) => {
    return fetch.post('graduation/course/certify', data)
}

export default {
    headers,
    onSelect,
    setRefresh,
    getSelection,
    querySearch,
    getDetailById,
    getDetailByInfo,
    getTermByBatchCode,
    delete: remove,
    update,
    download: `${fetch.base}graduation/result/file/download/`,
    saveComment,
    getStudentContentById,
    queryCourseType,
    courseTypeControl,
    submit,
    back,
    certify,
}

